export const baseURL = `${import.meta.env.VITE_AUTH_API}/api`
